.no-results button {
    z-index: 10;
    position: absolute;
    text-align: center;
    left: 50%;
    top: 300px;
}
